import { defineMessages } from 'react-intl';

export default defineMessages({
    back: {
        id: 'wmic-pe-portalwizard-components-ui.wizard.WMICWizard.Back',
        defaultMessage: 'Back',
    },
});
